import { normalizeTagName } from './normalize-tag-name.js';
/** Stands in for a tag's id in a rule until the tag is created on save. */
export function stagedTagKey(name) {
    return `new:${normalizeTagName(name)}`;
}
//# sourceMappingURL=staged-tag-key.js.map